import { store } from '../../../redux/store'
import { userSelectors } from '../../../redux/userSlice'
import { fetchHelper } from '../../../api/api'
import { userClassesActions } from './userClassesSlice'
import moment from 'moment'

export const fetchClass = classId => {
    const promises = [
        fetchHelper.get(`Inclass/${classId}`).then(res => res.data),
        fetchHelper.get(`Inclass/GetExtras/${classId}`).then(res => res.data),
    ]
    return Promise.all(promises).then(([classItem, classExtras]) => ({
        ...classItem,
        ...classExtras,
    }))
}

export const fetchUserClasses = () => {
    const state = store.getState()
    const userDetails = userSelectors.userDetails(state)
    return fetchHelper
        .get(`Inclassregistration/MyClasses/${userDetails.email}`)
        .then(res => res.data)
        .then(classes => {
            return Promise.all(
                classes.map(({ classid }) => fetchClass(classid))
            )
        })
}

export const getUserClasses = () => async dispatch => {
    dispatch(userClassesActions.getUserClassesRequest())
    try {
        const apiResponse = await fetchUserClasses()
        const classes = {},
            all = [],
            ongoing = [],
            completed = [],
            upcoming = []
        apiResponse.forEach(classItem => {
            const id = classItem.classid
            // map each class' id => the class
            classes[id] = classItem
            all.push(id)
            // the class hasn't begun, it's upcoming
            if (moment() < moment(classItem.startdate)) {
                upcoming.push(id)
                // the class is currently taking place
            } else if (moment() < moment(classItem.enddate)) {
                ongoing.push(id)
                // the class has already taken place
            } else {
                completed.push(id)
            }
        })
        dispatch(
            userClassesActions.getUserClassesRequestSuccess({
                classes,
                categories: {
                    all,
                    ongoing,
                    upcoming,
                    completed,
                },
            })
        )
    } catch (error) {
        if (process.env.NODE_ENV === 'development') console.warn(error)
        dispatch(userClassesActions.getUserClassesRequestFailure(error.message))
    }
}
